// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { useGetApi } from "../client";
import { useCallback } from "react";

export function useDeleteMandantFreedays(): (
  mandantId: string,
  freedayId: string
) => Promise<void> {
  const getAPI = useGetApi();
  return useCallback(
    async (mandantId, freedayId) =>
      (await getAPI()).mandanten.deleteMandantFreedays({
        mandantId,
        freedayId,
      }),
    [getAPI]
  );
}
